import { emitPageView } from 'store/userEnvironment/userEnvironmentActions';

const emitLocationChangeEvent = (action) => {
  return {
    event: 'Page Variables Ready',
    ...action.payload,
  };
};

export default { [emitPageView]: emitLocationChangeEvent };
